import {fetchJSON} from "../../utils/dataAccess";

export function loadCategories() {
  return dispatch => {
    fetchJSON('/knockout_question_bank_categories?pagination=false').then((categories) => {
      dispatch(categoriesLoaded(categories['hydra:member'].map(
        function (category) {
          return {
            value: category['@id'],
            text: category.name,
          }
        }
      )));
    }).catch(e => {
      dispatch(error(e.message));
    })
  };
}

export function error(error) {
  return {type: 'KNOCKOUTQUESTIONBANK_CATEGORIES_LOAD_ERROR', error};
}

export function categoriesLoaded(categories) {
  return {type: 'KNOCKOUTQUESTIONBANK_CATEGORIES_LOADED', categories};
}

export function reset() {
  return {type: 'KNOCKOUTQUESTIONBANK_CATEGORIES_RESET'};
}
